<template>
    <b-modal id="modalBlogSearch" size="lg" centered title="Large Modal">
     
        <input type="text" 
          v-model="keyword" 
          name="searchBlog" 
          value="" 
          onfocus="if(this.value == 'value') { this.value = ''; }" 
          
          v-on:keyup.enter="handleSubmit" placeholder="Search title blog">
        <div class="fit-catagory">
          <h5>Filter Category</h5>
          <b-badge 
            v-for="item in blogCategories" 
            v-bind:class="isActive(item.slug)"
            v-on:click="setSelectedCategory(item.slug)"
            :key="item.id" 
            class="badge">
            {{ item.category }}
          </b-badge>
          <div style="margin:10px 0 0 0">
            <button class='btn btn-primary' @click="handleSubmit"> Search </button>
          </div>
        </div>
       
    </b-modal>
</template>
<script>
    import BlogCategoryApi from "~/api/blog_categories.js"
    import BlogApi from "~/api/blogs.js"
    
    export default {
        data:function(){
            return {
                keyword:"",
                blogCategories:[],
                selectedCategorySlug:""
            }
        },
        methods:{
          isActive(categorySlug) {
            if(categorySlug === this.selectedCategorySlug) {
             
              return "badge-warning"
            } else {
              return ""
            }
          },
          setSelectedCategory(categorySlug) {
            this.selectedCategorySlug = categorySlug
          },
          handleSubmit() {
              var keyword = this.keyword.replace(" ","-")
              var queryString = ""

              if(this.selectedCategorySlug !== "") {
                queryString += `?category=${this.selectedCategorySlug}`
              }
              
              window.location = `/blog/search/${keyword}${queryString}`
          },
        },
        computed:{

        },
        beforeMount() {
          let blogCategoriesObj = new BlogCategoryApi(this.$axios)

          blogCategoriesObj.getAll()
            .then(res => {
              let blogCategories = res.data

              blogCategories.forEach(element => {
                this.blogCategories.push( element )
              });
            })
            .catch(err => {
              // console.log(err)
            })
        }
    }

</script>
